import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";

export default function LoginPage() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/login`, {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: new URLSearchParams({ username: email, password }),
            });

            if (!res.ok) throw new Error("Invalid credentials");

            const data = await res.json();
            localStorage.setItem("token", data.access_token);

            navigate("/"); // redirect to MapPage
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const containerStyle = {
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
        display: "flex",
        flexDirection: "column",
    };

    const mainContentStyle = {
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px 20px",
    };

    const formContainerStyle = {
        backgroundColor: "white",
        padding: "40px",
        borderRadius: "12px",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
        width: "100%",
        maxWidth: "400px",
    };

    const titleStyle = {
        textAlign: "center",
        marginBottom: "30px",
        fontSize: "28px",
        fontWeight: "600",
        color: "#333",
    };

    const inputStyle = {
        width: "100%",
        padding: "12px 16px",
        margin: "8px 0",
        border: "2px solid #ddd",
        borderRadius: "6px",
        fontSize: "16px",
        boxSizing: "border-box",
        transition: "border-color 0.3s ease",
    };

    const buttonStyle = {
        width: "100%",
        padding: "14px",
        margin: "20px 0 10px 0",
        backgroundColor: "#000",
        color: "white",
        border: "none",
        borderRadius: "6px",
        fontSize: "16px",
        fontWeight: "600",
        cursor: loading ? "not-allowed" : "pointer",
        transition: "background-color 0.3s ease",
        opacity: loading ? 0.7 : 1,
    };

    const errorStyle = {
        color: "#dc3545",
        fontSize: "14px",
        marginTop: "10px",
        textAlign: "center",
    };

    return (
        <div style={containerStyle}>
            <Header showLogout={false} />
            
            <div style={mainContentStyle}>
                <div style={formContainerStyle}>
                    <h2 style={titleStyle}>Sign In</h2>
                    <form onSubmit={handleSubmit}>
                        <input
                            type="email"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            style={inputStyle}
                        />
                        <input
                            type="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            style={inputStyle}
                        />
                        <button 
                            type="submit" 
                            style={buttonStyle}
                            disabled={loading}
                        >
                            {loading ? "Signing In..." : "Sign In"}
                        </button>
                    </form>
                    {error && <div style={errorStyle}>{error}</div>}
                </div>
            </div>
        </div>
    );
}